import { Put } from "../http/httpVerbs";


export const apiBulkUpdateFranchises = async (communityId, csvFile) => {
  try {
    const formData = new FormData();
    formData.append('csvFile', csvFile);

    const url = `${process.env.REACT_APP_API_URL}/comunidades/${communityId}/franchises/bulk-update`;

    const result = await Put(url, formData);

    return {
      success: true,
      message: result.message,
      statistics: {
        created: result.created,
        activated: result.activated,
        deactivated: result.deactivated,
        total: result.total
      }
    };
  } catch (error) {
    console.error("Error bulk updating franchises:", error);
    return {
      success: false,
      error: error.message || "Erro ao atualizar unidades"
    };
  }
};
